import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";
// import { normParam } from '@/tools'
// import Vue from 'vue'

// const M_API = API + '/warga'
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
const RTOKEN = "rToken";

const store = {
  namespaced: true,
  state: {
    warga: null,
    config: null,
    token: lc.getItem(TOKEN),
    rToken: lc.getItem(RTOKEN),
    permission: [],
    roles: [],
    meta: null,
    promiseRT: null,
    arrayOfRT: [],
    retryRefresh: true
  },
  getters: {
    warga(state) {
      return state.warga;
    },
    permission(state) {
      return state.permission;
    },
    wargaMeta(state) {
      return state.meta ? state.meta.wargas_meta : null;
    },
    roles(state) {
      return state.roles;
    },
    check(state) {
      return state.token;
    },
    token(state) {
      return state.token;
    },
    rToken(state) {
      return state.rToken;
    },
    promiseRT(state) {
      return state.promiseRT;
    },
    arrayOfRT(state) {
      return state.arrayOfRT;
    },
    retryRefresh(state) {
      return state.retryRefresh;
    }
  },
  actions: {
    // eslint-disable-next-line
    get({}, { params }) {
      return axios
        .get(`${M_API}/warga${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    cekNIK({}, { params }) {
      return axios
        .get(`${M_API}/warga_nik${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    previewKTA({}, id) {
      return axios
        .get(`${M_API}/warga/${id}/preview`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    cekData({}, kota_id) {
      if (kota_id) {
        return axios
          .get(`${M_API}/warga_belum_lengkap?kota_id=` + kota_id)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    getDetil({}, id) {
      return axios
        .get(`${M_API}/warga/${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    unduh({ state, getters, rootState, rootGetters }, dokumen) {
      // const j = rootGetters["user/token"];
      var url = dokumen.berkas.file.origin;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetak({ state, getters, rootState, rootGetters }, endpoint) {
      window.open(endpoint, "_blank");
    },
    // eslint-disable-next-line
    cetakKTP({ state, getters, rootState, rootGetters }, endpoint) {
      window.open(endpoint, "_blank");
    },
    cetakKTAKTP(_, endpoint) {
      return axios
        .get(endpoint)
        .then(res => {
          window.open(res.data.url_ktp_kta, "_blank");
        })
        .catch(err => Promise.reject(err));
    },
    cetakktpktafilter(_, { params }) {
      var url = `${API}/api/warga_cetak_ktp_kta${normParam(params)}`;
      window.open(url, "_blank");
    },
    cetakfilter(_, { params }) {
      var url = `${API}/api/warga_cetak_kta${normParam(params)}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    downloadXls({ state, getters, rootState, rootGetters }, { params }) {
      var url = `${API}/api/warga_download_link_kta${normParam(params)}`;
      window.open(url, "_blank");
    },
    downloadSP({ state, getters, rootState, rootGetters }, { obj, params }) {
      var url = `${API}/api/warga/${obj.id}/download_surat_pernyataan${normParam(params)}`;
      window.open(url, "_blank");
    },
    previewZIP(_, { params }) {
      var url = `${API}/api/warga_download_zip${normParam(params)}`;
      return axios
        .get(url)
        .then(res => {
          return res.data;
          // window.open(res.data.url_zip, "_blank");
        })
        .catch(err => Promise.reject(err));
    },
    downloadZIP(_, { params }) {
      var url = `${API}/api/warga_download_zip${normParam(params)}`;
      return axios
        .get(url)
        .then(res => {
          window.open(res.data.url_zip, "_blank");
          return res;
        })
        .catch(err => Promise.reject(err));
    },
    previewZIPCADANGAN(_, { params }) {
      var url = `${API}/api/warga_download_zipcadangan${normParam(params)}`;
      return axios
        .get(url)
        .then(res => {
          return res.data;
          // window.open(res.data.url_zip, "_blank");
        })
        .catch(err => Promise.reject(err));
    },
    downloadZIPCADANGAN(_, { params }) {
      var url = `${API}/api/warga_download_zipcadangan${normParam(params)}`;
      return axios
        .get(url)
        .then(res => {
          window.open(res.data.url_zip, "_blank");
          return res;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    downloadKategoriXls({ state, getters, rootState, rootGetters }, { obj, params }) {
      const j = rootGetters["user/token"];
      params.access_token = j;
      params.kategori_id = obj.id;
      // var params = {
      //   kota_id: kota_id,
      //   kategori_id: obj.id,
      //   access_token: j
      // }
      var url = `${API}/api/warga_download${normParam(params)}`;

      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakGambarDepan({ state, getters, rootState, rootGetters }, endpoint) {
      // const j = rootGetters["user/token"];
      var url = endpoint;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakGambarBelakang({ state, getters, rootState, rootGetters }, endpoint) {
      // const j = rootGetters["user/token"];
      var url = `${endpoint}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakCustom({ state, getters, rootState, rootGetters }, { obj, kota_id }) {
      // const j = rootGetters["user/token"];
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak_kta?from=${obj.from}&kota_id=${kota_id}&to=${obj.to}&access_token=${j}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    preview({ state, getters, rootState, rootGetters }, { obj, kota_id }) {
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak_kta?from=${obj.from}&kota_id=${kota_id}&to=${obj.to}&access_token=${j}&is_preview=true`;
      return axios
        .get(url)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    previewByNama({ state, getters, rootState, rootGetters }, { obj, kota_id }) {
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak_kta?kota_id=${kota_id}&access_token=${j}&is_preview=true`;

      obj.forEach((i, index) => {
        url = url + `&userids[${index}]=${i.id}`;
      });

      return axios
        .get(url)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    // eslint-disable-next-line
    cetakCustomByNama({ state, getters, rootState, rootGetters }, { obj, kota_id }) {
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak_kta?&kota_id=${kota_id}&access_token=${j}`;
      obj.forEach((i, index) => {
        url = url + `&userids[${index}]=${i.id}`;
      });
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakCustomByKategori({ state, getters, rootState, rootGetters }, { obj, params }) {
      const j = rootGetters["user/token"];
      params.access_token = j;
      params.kategori_id = obj.id;
      // var params = {
      //   kota_id: kota_id,
      //   kategori_id: obj.id,
      //   access_token: j
      // }
      var url = `${API}/api/warga_cetak_kta${normParam(params)}`;

      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakMasal({ state, getters, rootState, rootGetters }, { kecamatan_id, obj }) {
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak?from=${obj.from}&to=${obj.to}&kecamatan_id=${kecamatan_id}&access_token=${j}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    cetakMasalPengurus({ state, getters, rootState, rootGetters }, wilayah_id) {
      const j = rootGetters["user/token"];
      var url = `${M_API}/warga_cetak_pengurus?wilayah_id=${wilayah_id}&access_token=${j}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    getAgama({}, { params }) {
      return axios
        .get(`${M_API}/master?master=agama`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidatKTA({}, { s, kotaid }) {
      return axios
        .get(`${M_API}/warga_cetak_kta_cari?s=${s}&kota_id=${kotaid}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getOrganisasi({}, { params }) {
      return axios
        .get(`${M_API}/master?master=organisasi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKategori({}, { params }) {
      return axios
        .get(`${M_API}/master?master=kategori`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getHubunganKeluarga({}, { params }) {
      return axios
        .get(`${M_API}/master?master=status_hubungan_keluarga`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getProvinsi({}, { params }) {
      return axios
        .get(`${M_API}/master?master=propinsi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKota({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kota&propinsi_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKecamatan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kecamatan&kota_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelurahan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kelurahan&kecamatan_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPekerjaan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=status_pekerjaan`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    rotate({}, obj) {
      return axios
        .post(`${M_API}/rotate-ktp`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setOpsi({}, opsi) {
      return axios
        .post(`${M_API}/lingkup_hidden`, {is_hidden: opsi})
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    generateNomor({}, obj) {
      return axios
        .post(`${M_API}/warga/${obj.id}/generate_nomer_anggota`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    regenerateKTPKTA({}, obj) {
      return axios
        .post(`${M_API}/regenerate-ktp-kta`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setunggahsurat(_, { obj, value }) {
      obj.is_unggahsurat = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setunggahsurat`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setsipol(_, { obj, value }) {
      obj.is_sipol = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setsipol`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setverfak(_, { obj, value }) {
      obj.is_ms_verfak = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setverfak`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    sethapussipol(_, { obj, value }) {
      obj.is_hapus_sipol = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/sethapussipol`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setdaftarverfak(_, { obj, value }) {
      obj.is_daftar_verfak = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setdaftarverfak`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setsampling(_, { obj, value }) {
      obj.is_sampling = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setsampling`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setcetakkta(_, { obj, value }) {
      obj.is_cetak = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/setcetakkta`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setvalidasi(_, { obj, value }) {
      obj.validasi_lindungi_hak_mu = value;
      return axios
        .put(`${M_API}/warga/${obj.id}/validasi_lindungi_hak_mu`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setvalidasis(_, { obj }) {
      return axios
        .put(`${M_API}/warga/${obj.id}/validasi`, {})
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    generateNomorMasal({}, obj) {
      return axios
        .post(`${M_API}/warga_generate_nomer_anggota_all`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    validasi({}, obj) {
      return axios
        .post(`${M_API}/warga_validasi_all`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    form({}, obj) {
      // if (obj.id) {
      //   return axios
      //     .put(`${M_API}/warga/${obj.id}`, obj)
      //     .then(res => {
      //       return res;
      //     })
      //     .catch(e => e);
      // } else {
      //   return axios
      //     .post(`${M_API}/warga`, obj)
      //     .then(res => {
      //       return res;
      //     })
      //     .catch(e => e);
      // }
      if (obj.id) {
        let formData = new FormData();
        formData.append("id", obj.id);
        formData.append("nik", obj.nik);
        formData.append("nama", obj.nama);
        formData.append("status_pekerjaan_id", obj.status_pekerjaan_id);
        formData.append("alamat", obj.alamat);

        formData.append("rt", obj.rt);
        formData.append("rw", obj.rw);
        formData.append("propinsi_id", obj.propinsi_id);
        formData.append("kota_id", obj.kota_id);
        formData.append("kecamatan_id", obj.kecamatan_id);
        formData.append("kelurahan_id", obj.kelurahan_id);
        formData.append("kategori_id", obj.kategori_id);
        formData.append("keterangan", obj.keterangan);
        if (obj.organisasi.length == 0) {
          formData.append("organisasi", null);
        }

        obj.organisasi.forEach(function(value, i) {
          formData.append("organisasi[" + i + "]", value.id);
        });
        //opsional
        if (obj.nomer_kartu_keluarga) {
          formData.append("nomer_kartu_keluarga", obj.nomer_kartu_keluarga);
        }
        if (obj.kelamin) {
          formData.append("kelamin", obj.kelamin);
        }
        if (obj.status_hubungan_keluarga_id) {
          formData.append("status_hubungan_keluarga_id", obj.status_hubungan_keluarga_id);
        }
        if (obj.tempat_lahir) {
          formData.append("tempat_lahir", obj.tempat_lahir);
        }
        if (obj.tanggal_lahir) {
          formData.append("tanggal_lahir", obj.tanggal_lahir);
        }
        if (obj.agama_id) {
          formData.append("agama_id", obj.agama_id);
        }
        if (obj.telp) {
          formData.append("telp", obj.telp);
        } else {
          formData.append("telp", "");
        }
        if (obj.golongan_darah) {
          formData.append("golongan_darah", obj.golongan_darah || null);
        }
        if (obj.status_perkawinan) {
          formData.append("status_perkawinan", obj.status_perkawinan || null);
        }
        if (obj.kewarganegaraan) {
          formData.append("kewarganegaraan", obj.kewarganegaraan || null);
        }
        if (obj.foto) {
          formData.append("foto", obj.foto);
        }
        if (obj.ktp) {
          formData.append("ktp", obj.ktp);
        }
        return axios.post(`${M_API}/warga/${obj.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } else {
        let formData = new FormData();
        formData.append("nik", obj.nik);
        formData.append("nama", obj.nama);
        formData.append("status_pekerjaan_id", obj.status_pekerjaan_id);
        formData.append("alamat", obj.alamat);
        formData.append("rt", obj.rt);
        formData.append("rw", obj.rw);
        formData.append("propinsi_id", obj.propinsi_id);
        formData.append("kota_id", obj.kota_id);
        formData.append("kecamatan_id", obj.kecamatan_id);
        formData.append("kelurahan_id", obj.kelurahan_id);
        formData.append("kategori_id", obj.kategori_id);
        formData.append("keterangan", obj.keterangan);
        if (obj.organisasi.length == 0) {
          formData.append("organisasi", null);
        }
        if (obj.telp) {
          formData.append("telp", obj.telp);
        } else {
          formData.append("telp", "");
        }
        obj.organisasi.forEach(function(value, i) {
          formData.append("organisasi[" + i + "]", value.id);
        });
        //opsional
        if (obj.nomer_kartu_keluarga) {
          formData.append("nomer_kartu_keluarga", obj.nomer_kartu_keluarga);
        }
        if (obj.kelamin) {
          formData.append("kelamin", obj.kelamin);
        }
        if (obj.status_hubungan_keluarga_id) {
          formData.append("status_hubungan_keluarga_id", obj.status_hubungan_keluarga_id);
        }
        if (obj.tempat_lahir) {
          formData.append("tempat_lahir", obj.tempat_lahir);
        }
        if (obj.tanggal_lahir) {
          formData.append("tanggal_lahir", obj.tanggal_lahir);
        }
        if (obj.agama_id) {
          formData.append("agama_id", obj.agama_id);
        }
        if (obj.golongan_darah) {
          formData.append("golongan_darah", obj.golongan_darah || null);
        }
        if (obj.status_perkawinan) {
          formData.append("status_perkawinan", obj.status_perkawinan || null);
        }
        if (obj.kewarganegaraan) {
          formData.append("kewarganegaraan", obj.kewarganegaraan || null);
        }

        if (obj.foto) {
          formData.append("foto", obj.foto);
        }
        if (obj.ktp) {
          formData.append("ktp", obj.ktp);
        }
        return axios.post(`${M_API}/warga`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      }
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/warga/${item.id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    upload(_, { kota_id, file }) {
      console.log("called");
      let formData = new FormData();
      formData.append("file_exel", file);

      formData.append("kota_id", kota_id);

      return axios.post(`${M_API}/warga_excel_cek`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
  }
};

export default store;
